module.exports = __webpack_public_path__ + "img/denmark.67865113.svg";